import * as Scrivito from "scrivito"
import { ScrivitoAttributes } from "shared/types/ScrivitoAttributes"

export const ProductAddonObjClass = Scrivito.provideObjClass("ProductAddon", {
  attributes: {
    title: "string",
    image: ["reference", { only: "Image" }],
    imageWidgets: ["widgetlist", { only: "ImageWidget" }],
    productType: "string",
    description: "stringlist",
    baseVariants: ["referencelist", { only: "ProductBaseVariant" }]
  }
})

export type ProductAddonObj = InstanceType<typeof ProductAddonObjClass>
export type ProductAddonAttributes = ScrivitoAttributes<ProductAddonObj>
